import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für den Admin-Bereich. Rendert NUR die Kind-Routen via <Outlet/>.
// Der /admin-Inhalt (Übersicht) liegt in admin.index.tsx. Ohne <Outlet/> würden
// alle /admin/*-Kinder (Punkt-Notation = Nesting in TanStack) nicht erscheinen
// und stattdessen den Parent rendern.
export const Route = createFileRoute('/admin')({
  component: AdminAreaLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['ceo', 'internal_staff']);
  },
});

function AdminAreaLayout() {
  return <Outlet />;
}
